<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Ewaluacja projektów unijnych</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Ewaluacja służy, między innymi:
                    </div>
                    <v-list dense disabled>

                      <v-list-item
                        v-for="(item, i) in goals"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div class="text-body-1 text--primary">
                      Nasza firma stosuje w praktyce cztery rodzaje badań ewaluacyjnych:
                    </div>
                    <v-list disabled>

                      <v-list-item
                        v-for="(item, j) in types"
                        :key="j"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <non-eligible-expenditure-form />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  import NonEligibleExpenditureForm from "@/modules/forms/NonEligibleExpenditureForm";
  export default {
  
    components: {TextHeading, NonEligibleExpenditureForm},

    data: () => ({
      goals: [
        {
          text: 'określenia kierunków i celów badań',
          icon: "mdi-circle-medium"
        },
        {
          text: 'zbadania potrzeb projektodawcy czy beneficjenta',
          icon: "mdi-circle-medium"
        },
        {
          text: 'zwiększenia skuteczności i użyteczności prowadzonego projektu',
          icon: "mdi-circle-medium"
        },
        {
          text: 'określania stopnia zgodności z założonymi celami/rezultatami/produktami',
          icon: "mdi-circle-medium"
        },
        {
          text: 'sygnalizowania pojawiających się problemów',
          icon: "mdi-circle-medium"
        },
        {
          text: 'identyfikowania silnych i słabych stron przedsięwzięcia',
          icon: "mdi-circle-medium"
        },
        {
          text: 'wspomagania procesu podejmowania kluczowych decyzji',
          icon: "mdi-circle-medium"
        },
      ],
      types: [
        {
          text: 'ewaluacja ex-ante - realizowana na początku realizacji projektu. Ma na celu określenie zapotrzebowanie na konkretnie działanie, przed jego wdrożeniem. Diagnozuje potrzeby i oczekiwania grupy docelowej.',
          icon: "mdi-circle-medium"
        },
        {
          text: 'ewaluacja mid-term - realizowana w połowie realizowanego projektu. Ma na celu dokonanie pierwszej oceny jakości realizowanego przedsięwzięcia oraz jego rezultatów, a także może przyczynić się do pewnych modyfikacji czy interwencji w realizowanym projekcie.',
          icon: "mdi-circle-medium"
        },
        {
          text: 'ewaluacja on-going - realizowana przez cały okres realizacji przedsięwzięcia. Ma charakter uzupełniający w stosunku do innych rodzajów ewaluacji i służy przede wszystkim bieżącemu usprawnianiu zarządzania projektem.',
          icon: "mdi-circle-medium"
        },
        {
          text: 'ewaluacja ex-post - realizowana po zakończeniu projektu. Ocenia w jakim stopniu zostały osiągnięte cele i rezultaty zakładane w projekcie. Jej wyniki służą nie tylko kompleksowemu podsumowaniu projektu jak również stanowią cenne źródło informacji w planowaniu kolejnych przedsięwzięć.',
          icon: "mdi-circle-medium"
        },
      ]
    }),
  }
  </script>